import { createRouter, createWebHashHistory } from 'vue-router'
import { isSignedIn } from '@/plugins/auth'

import DefaultLayout from '@/layouts/DefaultLayout'
import api from '@/plugins/axios'

// FIX: erro crítico, agora lê no momento da verificação, sempre atualizado
function havePermission(route, routeName = null) {
  const user = JSON.parse(localStorage.getItem('user'))
  if (!user) return false
  const modulesPermission = user.modules_permission
    ? JSON.parse(user.modules_permission)
    : []
  return (
    isSignedIn() &&
    (user.role === 'super_admin' ||
      modulesPermission.includes(route) ||
      (routeName && modulesPermission.includes(routeName)) ||
      (route === '/transferencia-usuarios' &&
        (modulesPermission.includes('Transferência de Usuários') ||
          modulesPermission.includes('Transferencia de Usuarios'))))
  )
}

function registerLog(routerName) {
  if (!isSignedIn() || !localStorage.getItem('jwt')) {
    return
  }
  api
    .post(`/logs/new-action`, {
      routeName: routerName,
    })
    .then(() => {})
    .catch(() => {})
}

setTimeout(300)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
        beforeEnter(_, __, next) {
          registerLog('Dashboard')
          if (isSignedIn()) {
            next()
            return
          }
          next('/login')
        },
      },
      {
        path: '/403',
        name: 'NotAuthorized',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/NotAuthorized.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('NotAuthorized')
          if (isSignedIn()) {
            next()
            return
          }
          next('/login')
        },
      },
      {
        path: '/usuarios',
        name: 'Usuarios',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Usuarios/Usuarios.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Usuarios')
          if (havePermission('/usuarios')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/usuarios/criar',
        name: 'Criar Usuario',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Usuarios/CriarUsuario.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('CriarUsuario')
          if (havePermission('/usuarios/criar')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/usuarios/editar/:id',
        name: 'Editar Usuario',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Usuarios/EditarUsuario.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('EditarUsuario')
          if (havePermission('/usuarios/editar/:id')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/logs',
        name: 'Logs',
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Logs/Logs.vue'),
        beforeEnter(_, __, next) {
          registerLog('Logs')
          if (havePermission('/logs')) {
            next()
            return
          }
          next('/403')
        },
      },

      {
        path: '/CriarConcurso',
        name: 'Criar Concurso',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/CriarConcurso.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Criar Concurso')
          if (havePermission('/CriarConcurso')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/EnviarResultado',
        name: 'Enviar Resultado',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/EnviarResultado.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Enviar Resultado')
          if (havePermission('/EnviarResultado')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/Saques',
        name: 'Saques Loteria',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Saques.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('LoteriaSaques')
          if (havePermission('/Saques')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/gateways-saque',
        name: 'Gateways de Saque',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/GatewaysSaque.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('GatewaysSaque')
          if (havePermission('/gateways-saque')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/auditoria-combos',
        name: 'Auditoria de Combos',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/AuditoriaCombos.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('AuditoriaCombos')
          if (isSignedIn()) {
            next()
            return
          }
          next('/login')
        },
      },
      {
        path: '/ExcluirConcurso',
        name: 'Editar Concurso',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ExcluirConcurso.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('EditarConcurso')
          if (havePermission('/ExcluirConcurso')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/AgendarConcurso',
        name: 'Agendar Concurso',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/AgendarConcurso.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('AgendarConcurso')
          if (havePermission('/AgendarConcurso')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/modulo3',
        name: 'Lista Ganhadores',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Modulo3.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ListaGanhadores')
          if (havePermission('/modulo3')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/AprovarPremio',
        name: 'Aprovar Premio',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/AprovarPremio.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('AprovarPremio')
          if (havePermission('/AprovarPremio')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/AprovarPremioBichao',
        name: 'Aprovar Premio (Bichao)',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/AprovarPremioBichao.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('AprovarPremioBichao')
          if (havePermission('/AprovarPremioBichao')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/RelatorioFinanceiro',
        name: 'RelatorioFinanceiro',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/RelatorioFinanceiro.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('RelatorioFinanceiro')
          if (havePermission('/RelatorioFinanceiro')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/RelatorioFinanceiroUsuario',
        name: 'Relatorio Financeiro (Usuários)',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/RelatorioFinanceiroUsuarios.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('RelatorioFinanceiroUsuario')
          if (havePermission('/RelatorioFinanceiroUsuario')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/tipodejogo',
        name: 'Tipo de Jogo',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/TipoJogo.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('TipoJogo')
          if (havePermission('/tipodejogo')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/rifa',
        name: 'Rifa',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Rifa.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Rifa')
          if (havePermission('/rifa')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/layput/sidebar',
        name: 'Side Bar',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/IconesSideBar.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('LayoutSideBar')
          if (havePermission('/layput/sidebar')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/layput/corsite',
        name: 'Cor Site',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/CoresSite.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('LayoutCorSite')
          if (havePermission('/layput/corsite')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/layput/btnsite',
        name: 'BtnSite',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/BtnSite.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('LayoutBtnSite')
          if (havePermission('/layput/btnsite')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/layput/btnhome',
        name: 'BtnHome',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/BtnHome.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('LayoutBtnHome')
          if (havePermission('/layput/btnhome')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/trocanumero',
        name: 'Trocar Numero',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/TrocaNumero.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('TrocaNumero')
          if (havePermission('/trocanumero')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/descarrego',
        name: 'Descarrego',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Despacho.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('descarrego')
          if (havePermission('/descarrego')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/descarregoloterias',
        name: 'Descarrego Loteria',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/DescarregoLoteria.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('RelatorioFinanceiro2')
          if (havePermission('/descarregoloterias')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/descarregobanca',
        name: 'Descarrego por Banca',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/DescarregoBanca.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('DescarregoBanca')
          if (havePermission('/descarregobanca')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/config',
        name: 'Configuracoes',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Configuracoes.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Configuracoes')
          if (havePermission('/config')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/perfil',
        name: 'Perfil',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Perfil.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Perfil')
          // Todos os usuários autenticados podem acessar seu perfil
          next()
        },
      },
      {
        path: '/FacebookAds',
        name: 'Facebook ADS',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/FacebookAds.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('FacebookAds')
          if (havePermission('/FacebookAds')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ltvnew',
        name: 'LTV modalidade e bancas',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/LtvNew.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ltv modalidade e bancas')
          if (havePermission('/ltvnew')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ltvgeral',
        name: 'LTV Geral',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/LtvGeral.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ltv geral bancas')
          if (havePermission('/ltvnew')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ChangeConsultID',
        name: 'Change Consult ID',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ChangeConsultID.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ltv modalidade e bancas')
          if (havePermission('/ltvnew')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/popups',
        name: 'Popups',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/popupsnew.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Popups')
          if (havePermission('/popups')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/newbarrar',
        name: 'New Barrar',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/NewBarrar.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('New Barrar')
          if (havePermission('/newbarrar')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/Consultores',
        name: 'Consultores',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Consultores.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Consultores')
          if (havePermission('/Consultores')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/WhatsappNotification',
        name: 'Whatsapp Notification',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/WhatsappNotification.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('WhatsappNotification')
          if (havePermission('/WhatsappNotification')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/WhatsappCampaignMonitor',
        name: 'Monitor Campanhas WhatsApp',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/WhatsappCampaignMonitor.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('WhatsappCampaignMonitor')
          if (havePermission('/WhatsappCampaignMonitor')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/LinksAdsNew',
        name: 'Links Ads',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/LinksAdsNew.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('LinksAdsNew')
          if (havePermission('/LinksAdsNew')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/Faturamento',
        name: 'Análise de Faturamento',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Faturamento.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Faturamento')
          if (havePermission('/Faturamento')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/MetasVendas',
        name: 'Metas e Vendas',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/MetasVendas.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('MetasVendas')
          if (havePermission('/MetasVendas')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ConsultoresExport',
        name: 'Consultores (exportação)',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ConsultoresExport.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ConsultoresExport')
          if (havePermission('/ConsultoresExport') || havePermission('/MetasVendas')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/RelatorioVendasSemanais',
        name: 'Relatorio Vendas Semanais',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/RelatorioVendasSemanais.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('RelatorioVendasSemanais')
          if (havePermission('/RelatorioVendasSemanais')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/RelatorioDepositosSemanais',
        name: 'Relatorio Depositos Semanais',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/RelatorioDepositosSemanais.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('RelatorioDepositosSemanais')
          if (havePermission('/RelatorioDepositosSemanais')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/RelatorioComparativoSemanal',
        name: 'Relatorio Comparativo Semanal',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/RelatorioComparativoSemanal.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('RelatorioComparativoSemanal')
          if (havePermission('/RelatorioComparativoSemanal')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ComboBuyersReport',
        name: 'Compradores de combo',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ComboBuyersReport.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ComboBuyersReport')
          if (havePermission('/ComboBuyersReport')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/VendaRapidaReport',
        name: 'Venda Rápida',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/VendaRapidaReport.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('VendaRapidaReport')
          if (havePermission('/VendaRapidaReport')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/AprovacaoAutomatica',
        name: 'Aprovacao Automatica',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/AprovacaoAutomatica.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('AprovacaoAutomatica')
          if (havePermission('/AprovacaoAutomatica')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/AprovacaoAutomaticaBichao',
        name: 'Aprovacao Automatica (Bichao)',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/AprovacaoAutomaticaBichao.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('AprovacaoAutomaticaBichao')
          if (havePermission('/AprovacaoAutomaticaBichao')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/LogBancasPremios',
        name: 'Log Bancas Premios',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ApostasFeitas.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('LogBancasPremios')
          if (havePermission('/LogBancasPremios')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/GanhadoresBichao',
        name: 'Ganhadores (Bichao)',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/GanhadoresBichao.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('GanhadoresBichao')
          if (havePermission('/GanhadoresBichao')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ListaGanhadoresEscritorio',
        name: 'Lista Ganhadores Escritorio',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ListaGanhadoresEscritorio.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ListaGanhadoresEscritorio')
          if (havePermission('/ListaGanhadoresEscritorio')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/Modulo4',
        name: 'Sobrepor Resultado',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Modulo4.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('SobreporResultado')
          if (havePermission('/Modulo4')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/PegaLadrao',
        name: 'Pega Ladrao',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/PegaLadrao.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('PegaLadrao')
          if (havePermission('/PegaLadrao')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/Banners',
        name: 'Banners',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Banners.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Banners')
          if (havePermission('/Banners')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/Roleta',
        name: 'Roleta',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Roleta.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('Roleta')
          if (havePermission('/Roleta')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/CaixinhaSurpresa',
        name: 'Caixinha Surpresa',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/CaixinhaSurpresa.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('CaixinhaSurpresa')
          if (havePermission('/CaixinhaSurpresa')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/RelatorioConsultores',
        name: 'Relatorio Consultores',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/RelatorioConsultores.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('RelatorioConsultores')
          if (havePermission('/RelatorioConsultores')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/EntregaPlanoCarreira',
        name: 'Entrega Plano de Carreira',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/EntregaPlanoCarreira.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('EntregaPlanoCarreira')
          if (havePermission('/EntregaPlanoCarreira')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/AnaliseDezenas',
        name: 'Analise Dezenas',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/AnaliseDezenas.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('AnaliseDezenas')
          if (havePermission('/AnaliseDezenas')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/UsuariosBanca',
        name: 'Usuarios Bancas',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/Usuarios.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('UsuariosBanca')
          if (havePermission('/UsuariosBanca')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/UsuariosSaldo',
        name: 'Usuarios Saldo',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/UsuariosSaldo.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('UsuariosSaldo')
          if (havePermission('/UsuariosSaldo')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ComissoesDezenas',
        name: 'Comissões de Dezenas',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ComissoesDezenas.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ComissoesDezenas')
          if (havePermission('/ComissoesDezenas')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/ValoresSaqueNiveis',
        name: 'Limites de Saque Por Nivel',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/ValoresSaquesNiveis.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('ValoresSaqueNiveis')
          if (havePermission('/ValoresSaqueNiveis')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/central-logs/bancas',
        name: 'Central Logs — Bancas',
        component: () =>
          import(
            /* webpackChunkName: "central-logs" */ '@/views/CentralLogs/Bancas.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('CentralLogsBancas')
          if (havePermission('/central-logs/bancas')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/central-logs/regras',
        name: 'Central Logs — Regras',
        component: () =>
          import(
            /* webpackChunkName: "central-logs" */ '@/views/CentralLogs/Regras.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('CentralLogsRegras')
          if (havePermission('/central-logs/regras')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/central-logs',
        name: 'Central Logs — Visualização',
        component: () =>
          import(
            /* webpackChunkName: "central-logs" */ '@/views/CentralLogs/Logs.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('CentralLogs')
          if (havePermission('/central-logs')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/gerenciar-lives',
        name: 'Gerenciar Lives',
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '@/views/Modulos/GerenciarLives.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('GerenciarLives')
          if (havePermission('/gerenciar-lives')) {
            next()
            return
          }
          next('/403')
        },
      },
      {
        path: '/transferencia-usuarios',
        name: 'Transferência de Usuários',
        component: () =>
          import(
            /* webpackChunkName: "transfer-users" */ '@/views/Modulos/TransferenciaUsuarios.vue'
          ),
        beforeEnter(_, __, next) {
          registerLog('TransferenciaUsuarios')
          if (havePermission('/transferencia-usuarios')) {
            next()
            return
          }
          next('/403')
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Login.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
